module.exports = __webpack_public_path__ + "media/images/users-ec8f28c0f54472f69fe2bf101b2e489e.svg";